import React from 'react';
import './landingpage.css';

const LeadMagnet = () => {
  const photoUrl = process.env.PUBLIC_URL + '/squeezing-page/assets/Zielklar-Der Weg zu Ihren Träumen.jpeg';

  return (
    <div className="container">
      <div className="content">
        <h1 className="heading">Gratis Report klärt endlich auf ...</h1>
        <h2 className="subheading">Erhalte exklusives Wissen, deine Ziele zu erreichen</h2>
        <div className="image-container">
          <img src={photoUrl} alt='' className='ebook-image' />
        </div>
        <p className="description">
          Tragen Sie hier Ihre Kontakdaten ein und erhalten Sie den Report sofort und <span style={{ color: "red" }}>100% Gratis!</span>
        </p>
        <ul className="bulletpoints">
          <li>Sofortiger Zugang zu deinem kostenlosen eBook</li>
          <li>Schritt-für-Schritt-Anleitung</li>
          <li>Praktische Tipps, die du sofort anwenden kannst</li>
        </ul>
        
        {/* Quentn Formular Einbindung mit verbessertem Design */}
        <form action="https://srkmmd.eu-5.quentn-site.com/public/forms/56/raw/submit" method="post" className="email-form">
          <div className="name-fields">
            <div className="input-group">
              <label className="input-label">Vorname</label>
              <input type="text" name="first_name" required className="email-input" placeholder="Dein Vorname" />
            </div>
            <div className="input-group">
              <label className="input-label">Nachname</label>
              <input type="text" name="family_name" required className="email-input" placeholder="Dein Nachname" />
            </div>
          </div>
          <div className="input-group">
            <label className="input-label">E-Mail</label>
            <input type="email" name="mail" required className="email-input" placeholder="Deine E-Mail-Adresse" />
          </div>
          <button type="submit" className="submit-btn">Jetzt anfordern</button>
        </form>
        
        <p className="cta">Hol dir jetzt deinen kostenlosen Ratgeber und starte noch heute!</p>
        <p className="trust-element">Wir respektieren deine Privatsphäre. Deine Daten werden vertraulich behandelt.</p>
      </div>
    </div>
  );
};

export default LeadMagnet;
